import * as React from 'react'
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import {Arrows} from './Arrows'
import ListItem from '../course/components/list_item'

declare const I18n;

type Course = {
  featured?: boolean
  id: number
  title: string
  required_level: number
  cover_image_url?: string | null
  file_url?: string | null
  cover_image_data?: any
  image?: string | null
  description?: string
}

type Props = {
  courses: Array<Course>
  isFacilitator?: boolean
  isLearner?: boolean
  learnerLevel?: number
  heading: string
  viewAllText: string
  viewAllUrl: string
  emptyStateText: string
  showProgress?: boolean
  showBookIcon?: boolean
}

type State = {
  initialSettings: Record<string, any>
}

class FeaturedCourseSlider extends React.Component<Props, State> {
  private sliderRef: React.RefObject<Slider>

  constructor(props: Props) {
    super(props)

    this.sliderRef = React.createRef()

    this.state = {
      initialSettings: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: false,  // Add this
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      }
    }
  }

  getCoverImageUrl(coverImageData: any): string | null {
    if (!coverImageData) return null
    
    try {
      if (coverImageData.file_url) {
        return coverImageData.file_url
      }
      
      if (coverImageData.file_data) {
        const fileData = JSON.parse(coverImageData.file_data)
        return fileData.id || null
      }
      
      return null
    } catch {
      return null
    }
  }

  truncateText(text: string | undefined, maxLength: number = 150): string {
    if (!text || text === 'null') return ''
    
    const trimmed = text.trim()
    
    if (trimmed.length <= maxLength) {
      return trimmed
    }
    
    return trimmed.slice(0, maxLength) + '...'
  }

  handleDelete = (id: number) => {
  }

  render() {
    const { courses, isFacilitator, isLearner, learnerLevel, heading, viewAllText, viewAllUrl, emptyStateText, showProgress, showBookIcon} = this.props

    const inProgressCourses = courses.filter(course => !(course as any).completed)
    
    return (
      <div>
        <div className="resource-heading-container">
          <h2 className="slider-section-heading">
            {showBookIcon && (<i className="fa-solid fa-book-open icon-pink heading-icon"></i>)}
            {heading}
          </h2>
          {inProgressCourses.length > 3 && <Arrows sliderRef={this.sliderRef} />}
        </div>

        <div className="">
          {inProgressCourses && inProgressCourses.length > 0 ? (
            <div className="featured-resource-slider">
              <Slider ref={this.sliderRef} {...this.state.initialSettings}>
                {inProgressCourses.map((course, index) => {
                  const truncatedDescription = this.truncateText(course.description)
                  const coverUrl = (
                    course.cover_image_url ||
                    course.file_url ||
                    this.getCoverImageUrl(course.cover_image_data) ||
                    course.image ||
                    null
                  ) as string | null

                  const totalLessons = (course as any).total_lessons as number | undefined
                  const lessonsCompleted = (course as any).lessons_completed as number | undefined
                  const currentLesson = (course as any).current_lesson as { title?: string; number?: number } | undefined
                  const isInProgress = !!(
                    lessonsCompleted != null && lessonsCompleted > 0 && 
                    (totalLessons == null || lessonsCompleted < totalLessons)
                  )

                  return (
                    <div key={course.id} className="slider-card-wrapper">
                      <ListItem
                        cardBackground={'secondary'}
                        title={course.title}
                        description={truncatedDescription}
                        requiredLevel={course.required_level}
                        index={index}
                        id={course.id}
                        image={coverUrl || undefined}
                        isFacilitator={isFacilitator}
                        isLearner={isLearner}
                        learnerLevel={learnerLevel}
                        handleDelete={this.handleDelete}
                        lessonsCompleted={lessonsCompleted}
                        currentLessonTitle={currentLesson?.title}
                        currentLessonId={currentLesson?.id}
                        buttonLabel={isLearner ? (isInProgress ? (I18n.t("common.continue")) : (I18n.t("models.course.messaging.view_course"))) : undefined}
                        currentLessonNumber={currentLesson?.number}
                        totalLessons={showProgress ? totalLessons : null}
                      />
                    </div>
                  )
                })}
              </Slider>
            </div>
          ) : (
            <div className="empty-state text-center">
              {emptyStateText}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default FeaturedCourseSlider